import { motion } from "framer-motion";

// Generic scroll-reveal wrapper for sections / cards. For big kinetic
// headlines use KineticHeading instead (masked line reveal, no opacity fade).
export const Reveal = ({ children, delay = 0, y = 24, className, ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);
